export type FontName = 'inter' | 'poppins' | 'prompt'

export interface FontLoaderProps {
    fonts: FontName[]
}

const FONT_WEIGHTS = [100, 200, 300, 400, 500, 600, 700, 800, 900] as const

export const FONT_FAMILY_MAP: Record<FontName, string> = {
    inter: 'Inter',
    poppins: 'Poppins',
    prompt: 'Prompt'
}

const hiddenStyle: React.CSSProperties = {
    position: 'absolute',
    left: -99999
}

export function FontLoader({ fonts }: FontLoaderProps) {
    return (
        <div style={hiddenStyle}>
            {fonts.map(font => {
                const fontFamily = FONT_FAMILY_MAP[font]
                return FONT_WEIGHTS.map(fontWeight => (
                    <div key={`${font}-${fontWeight}`} style={{ fontFamily, fontWeight }}>
                        {fontFamily} {fontWeight}
                    </div>
                ))
            })}
        </div>
    )
}

export default FontLoader
